import { ListViewComponent } from "@syncfusion/ej2-react-lists";
import { useComments } from "../../hooks/useComments";
import { IBoltComment } from "../../types/IBoltComment";

export const useCommentsList = ({
  listViewRef,
  onEdit,
  onTogglePin,
  onDelete,
}: {
  listViewRef: React.RefObject<ListViewComponent | null>;
  onEdit?: (updatedComment: IBoltComment) => Promise<void>;
  onTogglePin?: (comment: IBoltComment) => Promise<void>;
  onDelete?: (comment: IBoltComment) => Promise<void>;
}) => {
  const commentsApi = useComments();

  const refreshComments = () => {
    listViewRef.current?.refresh();
  };

  const handleEdit = async (updatedComment: IBoltComment) => {
    try {
      await onEdit?.(updatedComment);
    } finally {
      refreshComments();
    }
  };

  const handleTogglePin = async (comment: IBoltComment) => {
    try {
      await commentsApi.updateComment(comment.id, {
        isPinned: !comment.isPinned,
      });

      try {
        await onTogglePin?.(comment);
      } finally {
        refreshComments();
      }
    } catch (error) {
      console.error("Failed to pin/unpin comment:", error);
    }
  };

  const handleDelete = async (comment: IBoltComment) => {
    try {
      await commentsApi.deleteComment(comment.id);

      try {
        await onDelete?.(comment);
      } finally {
        refreshComments();
      }
    } catch (error) {
      console.error("Failed to delete comment:", error);
    }
  };

  return {
    handleEdit,
    handleTogglePin,
    handleDelete,
    refreshComments,
  };
};
